import emptyTable from '@/components/helpers/EmptyTable'
import Loading from '@/components/helpers/Loading'
import DocumentToolbar from '../components/DocumentToolbar'
import DocumentsApi from '../api'

export default {
  data () {
    return {
      messageType: 'success',
      messageText: '',
      messageDisplay: false,
      loading: false,
      id: '',
      document: {
        created_on: '',
        modified_on: '',
        summa: '',
        comment: '',
        records: []
      }
    }
  },
  components: {
    emptyTable,
    DocumentToolbar,
    Loading
  },
  methods: {
    showMessage (messageText, mesageType) {
      this.messageText = messageText
      this.messageType = mesageType
      this.messageDisplay = true
    },
    closeDocument () {
      this.$router.push({ name: 'documents' })
    },
    async openDocument () {
      this.loading = true
      let response = await DocumentsApi.openDocument({ id: this.id, name: this.name })
      if (response.success) {
        response.document.summa = parseFloat(response.document.summa)
        this.document = response.document
      } else {
        console.log(response.error)
      }
      this.loading = false
    },
    async excel () {
      await DocumentsApi.excel({ id: this.id, name: this.name })
    }
  },
  beforeMount () {
    this.id = this.$route.params.docId
    this.openDocument()
  }
}
